import { Button, Typography } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import NewPage from '../components/NewPage';

const NotFound = () => {
  const history = useHistory();
  return (
    <NewPage title="NOT FOUND">
      <Typography variant="h5">존재하지 않는 페이지입니다.</Typography>
      <Typography>아패의 버튼을 선택하면 홈으로 이동합니다.</Typography>
      <Button
        color="secondary"
        variant="contained"
        onClick={() => history.replace('/')}
      >
        이전 페이지로 이동
      </Button>
    </NewPage>
  );
};

export default NotFound;
